var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"some-element1"}},[_vm._v("第一个")]),_c('div',{attrs:{"id":"some-element2"}},[_vm._v("第二2个")])])}]

export { render, staticRenderFns }